<template>
  <div class="expert-opinion-list" ref="expertOpinionBox">
    <h1>专家观点</h1>
    <div
      class="expert-opinion-list__item"
      v-for="item in listData.list"
      :key="item.id"
      @click="openDetail(item)"
    >
      <section>
        <div class="expert-opinion-list__image">
          <img :src="getImage(item)" :alt="getAuthor(item) || getTitle(item)">
        </div>
        <nav>
          <i></i>
          <div class="center_text">
            <h2 v-if="getAuthor(item)">{{ getAuthor(item) }}：</h2>
            <span>{{ getTitle(item) }}</span>
            <p>{{ getDescription(item) }}</p>
          </div>
        </nav>
      </section>
    </div>
    <div class="pagination">
      <Pagination :total="query.total" :page="query.page" :limit="query.limit" @pageChange="pageChanges" />
    </div>
  </div>
</template>

<script setup>
import Pagination from '@/components/Pagination.vue'
import { getHttp } from '@/api/API.js'
import fallbackImage from '@/assets/expert-opinion-placeholder.svg'
import { onMounted, reactive, ref, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'

const route = useRoute()
const router = useRouter()
const expertOpinionBox = ref(null)
const baseUrl = `${process.env.VUE_APP_BASE_URL}/`

const query = reactive({
  page: 1,
  limit: 10,
  total: 0,
  type_id: Number(route.params.id) || 612,
  is_en: 2
})

const listData = reactive({
  list: []
})

const getAuthor = (item) => {
  return item?.author_en || item?.author || ''
}
const getTitle = (item) => {
  return item?.title_en || item?.title || ''
}
const getDescription = (item) => {
  return item?.description_en || item?.description || ''
}
const getImage = (item) => {
  if (!item?.thumb) return fallbackImage
  return item.thumb.indexOf('http') !== -1 ? item.thumb : `${baseUrl}${item.thumb}`
}

const showContent = () => {
  if (!expertOpinionBox.value) return
  expertOpinionBox.value.style.opacity = 1
  expertOpinionBox.value.style.transform = 'translateY(0)'
}

const getList = async () => {
  const { data: res } = await getHttp('/api/article', query)
  if (res.code == 200) {
    listData.list = res.data.data
    query.total = res.data.total
    showContent()
  }
}

const pageChanges = (page) => {
  query.page = page
  document.documentElement.scrollTop = 0
  getList()
}

const openDetail = (item) => {
  router.push({
    name: 'Moearticlexq',
    params: {
      articleid: item.id,
      id: item.type_id || query.type_id,
      tid: route.params.tid || route.params.id || query.type_id,
      level: 1,
      isen: 2
    }
  })
}

watch(() => route.params.id, (id) => {
  query.type_id = Number(id) || 612
  query.page = 1
  getList()
})

onMounted(() => {
  if (expertOpinionBox.value) {
    expertOpinionBox.value.style.transform = 'translateY(500px)'
    expertOpinionBox.value.style.opacity = 0
  }
  getList()
})
</script>

<style lang="less" scoped>
@maxw:128rem;

.expert-opinion-list{
  width: 100%;
  transition: ease .8s;
  cursor: pointer;

  >h1{
    font-size: 39/@maxw;
    font-family: fantBold;
    font-weight: 300;
    color: #174994;
    border-bottom:2/@maxw solid #174994;
    margin: 0;
    padding: 0 0 10/@maxw 0;
  }

  &__item{
    margin-top: 40/@maxw;
    width: 100%;

    >section{
      display: flex;
      justify-content: space-between;
    }
  }

  &__image{
    img{
      width: 230/@maxw;
      height: 252/@maxw;
      background: #CBC9C9;
      transition: ease .3s;
      object-fit: cover;
    }
  }

  nav{
    position: relative;
    width: 874/@maxw;
    height: 252/@maxw;
    background-image: url("../../../assets/ejkybj2.png");
    background-size: 100% 100%;
    cursor: pointer;
    transition: ease .3s;
    margin-left: 20/@maxw;

    >i{
      position: absolute;
      top: 25/@maxw;
      left: 35/@maxw;
      width: 50/@maxw;
      height: 50/@maxw;
      background-image: url("../../../assets/ejky.png");
      background-size: 100% 100%;
    }

    >.center_text{
      margin-left: 110/@maxw;
      width: 715/@maxw;
      height: 100%;
      color: #174994;
      display: flex;
      flex-direction: column;
      justify-content: center;
      transition: ease .3s;

      h2{
        margin:-10/@maxw 0 15/@maxw 0;
        padding: 0;
        font-size: 32/@maxw;
        font-family: Source Han Sans CN-Heavy, Source Han Sans CN;
        font-weight: 800;
      }

      span{
        width: 610/@maxw;
        font-size: 31/@maxw;
        font-family: Source Han Sans CN-Medium;
        font-weight: 500;
        word-break: break-all;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 1;
        overflow: hidden;
      }

      p{
        font-family: Source Han Sans CN-Normal, Source Han Sans CN;
        font-weight: 300;
        font-size: 16/@maxw;
        color: #5F5F5F;
        margin: 21/@maxw 0 0;
        padding: 0;
        word-break: break-all;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
        transition: ease .3s !important;
      }
    }
  }

  &__item:hover{
    >section{
      .expert-opinion-list__image img{
        transform: scale(1.02);
      }

      nav{
        background-image: url("../../../assets/ejkybj1.png");

        >.center_text{
          color: #fff !important;

          p{
            color: #fff !important;
          }
        }
      }
    }
  }
}

.pagination{
  display: flex;
  justify-content: center;
  margin: 6% 0 0 0; 
}

@media screen and (max-width:750px) {
  @maxw_:750/100vw;

  .expert-opinion-list{
    margin: 0 !important;

    >h1{
      font-size: 35/@maxw_ !important;
      border-bottom:2/@maxw_ solid #174994;
    }

    &__item{
      >section{
        .expert-opinion-list__image{
          img{
            width: 230/@maxw_ !important;
            height: 252/@maxw_ !important;
          }
        }

        nav{
          flex: 1;
          height: 252/@maxw_;
          background-image: url("../../../assets/ejkybj2.png");
          margin-left: 20/@maxw;

          >i{
            top: 25/@maxw_;
            left: 15/@maxw_;
            width: 40/@maxw_;
            height: 40/@maxw_;
          }

          >.center_text{
            margin-left: 60/@maxw_;
            width: 700/@maxw_;

            h2{
              margin:-10/@maxw_ 0 15/@maxw_ 0;
              font-size: 32/@maxw_;
            }

            span{
              width: 350/@maxw_;
              font-size: 31/@maxw_;
            }

            p{
              width: 370/@maxw_;
              font-size: 23/@maxw_;
              margin-top: 21/@maxw_;
            }
          }
        }
      }
    }
  }
}
</style>
